module.exports = __webpack_public_path__ + "img/dongji_ps_24.b2b1b2f1.jpg";